import { RootState } from "../store";

export const getSearchProducts = (state: RootState) => {
    return state.productSlice.searchProducts;
};

export const getAdminSidebar = (state: RootState) => {
    return state.productSlice.adminSidebar;
};

export const getUserRole = (state: RootState) => {
    // @ts-ignore
    return state.productSlice.user?.role;
};
export const getCarState = (state: RootState) => {
    return state.productSlice.cars;
};
export const getModels = (state: RootState) => {
    return state.productSlice.models;
};
export const getEngines = (state: RootState) => {
    return state.productSlice.engine;
};
export const getBody = (state: RootState) => {
    return state.productSlice.bodies;
};
export const getGeneration = (state: RootState) => {
    return state.productSlice.generations;
};
export const getDetails = (state: RootState) => {
    return state.productSlice.details;
};
export const getLoading = (state: RootState) => {
    return state.productSlice.loading;
};
export const getIsAuth = (state: RootState) => {
    return state.productSlice.isAuth;
}
export const getRegistrationModal = (state: RootState) => {
    return state.productSlice.registrationModal;
}
export const getLoginModal = (state: RootState) => {
    return state.productSlice.loginModal;
}

export const getCatalog = (state: RootState) => {
    return state.productSlice.catalogs;
}
export const getHitsState = (state: RootState) => {
    return state.productSlice.hits
}
export const getCartState = (state: RootState) => {
    return state.productSlice.basket
}

export const getCarStateAdd = (state: RootState) => {
    return state.productSlice.carAdmin

};
export const getModelsAdd = (state: RootState) => {
    return state.productSlice.modelsAdmin
};
export const getEnginesAdd = (state: RootState) => {
    return state.productSlice.engineAdmin
};
export const getBodyAdd = (state: RootState) => {
    return state.productSlice.bodiesAdmin
};
export const getGenerationAdd = (state: RootState) => {
    return state.productSlice.generationsAdmin
};
export const getCatalogTypesState = (state: RootState) => {
    return state.productSlice.catalogTypes
}

export const getFilterCatalogState = (state: RootState) => {
    return state.productSlice.filtredCatalog
}